import React from 'react';

import CreateIcon from 'material-ui/svg-icons/content/add';
import { TextField, RadioButton, RadioButtonGroup, FlatButton } from 'material-ui';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import { translate as t } from 'admin-on-rest';

import { keys, random } from 'lodash';

export class TextArrayInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fields: keys(this.props.record).includes('question') ? this.props.record.choices : [],
    };
  }

  handleAddField = (e) => {
    e.preventDefault();
    const tempState = this.state.fields.slice();
    tempState.push({ id: this.state.fields.length + random(0, 1000), text: '', valid: false });
    this.setState({ fields: tempState });
  }

  handleChange = (index, e) => {
    const { value } = e.target;
    const fields = [...this.state.fields];
    const field = fields[index];
    field.text = value;
    this.props.input.onChange(fields);
  }

  handleRadioChange = (index, e) => {
    const { value } = e.target;
    const fields = [...this.state.fields];
    const field = fields[index];
    field.valid = Boolean(value);
    this.props.input.onChange(fields);
  }

  handleDelete = (index) => {
    const fields = [...this.state.fields];
    const filteredFields = fields.filter((item, i) => i !== index);
    this.setState({ fields: filteredFields });
    this.props.input.onChange(filteredFields);
  }

  render() {
    const { translate } = this.props;
    return (
      <div>
        {this.state.fields && this.state.fields.map((field, i) => (
          <div key={field.id}>
            <TextField hintText={this.props.label} defaultValue={field.text} onChange={(e) => this.handleChange(i, e)} source="choice" /> <br />

            <RadioButtonGroup name="choices" defaultSelected={field.valid} onChange={(e) => this.handleRadioChange(i, e)}>
              <RadioButton
                label={translate('correct')}
                value={true} // eslint-disable-line
              />
              <RadioButton label={translate('incorrect')} value={false} />
            </RadioButtonGroup>

            <FlatButton
              icon={<DeleteIcon />}
              label={translate('remove')}
              primary
              onClick={() => this.handleDelete(i)}
            />

          </div>
        ))}

        <FlatButton
          primary
          icon={<CreateIcon />}
          label={translate('add')}
          onClick={this.handleAddField}
        />

      </div>
    );
  }
}

TextArrayInput.defaultProps = {
  addField: true,
};

export default t((TextArrayInput));
